import React from "react";
import { func, string, arrayOf, object } from "prop-types";
import SwitchToggle from "../SwitchToggle/SwitchToggle.jsx";

const propTypes = {
  id: string.isRequired,
  onFacetChange: func.isRequired,
  values: arrayOf(object),
};

const ToggleGroup = (props) => {
  const { id, values, onFacetChange } = props;

  return (
    <section className="toggle-group">
      {values &&
        values.length > 0 &&
        values.map((value, i) => (
          <SwitchToggle
            key={value.id}
            groupId={id}
            facetId={value.id}
            facetCount={value.count}
            facetLabel={value.name}
            selected={value.selected}
            onFacetChange={onFacetChange}
          />
        ))}
    </section>
  );
};

ToggleGroup.propTypes = propTypes;
export default ToggleGroup;
